module.exports = __webpack_public_path__ + "static/media/command.ad753f28.svg";